import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({
  lines,
  className = "",
  lineClass = "",
  delay = 0,
  stagger = 0.12,
  when = "load",
  as = "span",
}) => {
  const Tag = motion[as] || motion.span;
  return (
    <Tag
      className={className}
      initial="off"
      {...(when === "load"
        ? { animate: "on" }
        : { whileInView: "on", viewport: { once: true, amount: 0.2 } })}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClass}`}
            variants={{ off: { y: "112%" }, on: { y: "0%" } }}
            transition={{ duration: 0.9, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
